import Spinner, {
	SvgWheel,
} from 'components/spinner/Spinner';
import './loadingWheel.scss';

interface LoadingWheelProps {
	message?: string;
	height?: string;
	width?: string;
}

const LoadingWheel = ({
	message,
	height = '3.5rem',
	width = '3.5rem',
}: LoadingWheelProps) => (
	<div className="loading-wheel">
		<Spinner>
			<SvgWheel height={height} width={width} />
		</Spinner>
		{message && (
			<div className="loading-wheel-text">
				{message}
			</div>
		)}
	</div>
);

export default LoadingWheel;